// extracted by mini-css-extract-plugin
export default {"home":"Home_home__WKU4V","header":"Home_header__Y5ipe","input":"Home_input__9Xy3-","projects":"Home_projects__PPbmg","project":"Home_project__uJu7X"};